<template>
  <div id="app">
    <v-app>
      <a href="#main-content" class="skip-link">Skip to main content</a>
      <gws-header v-if="!$route.meta.empty"></gws-header>
      <main v-if="!$route.meta.empty" id="main-content" tabindex="-1">
        <router-view />
      </main>
      <router-view v-else />
      <gws-footer v-if="!$route.meta.empty"></gws-footer>
    </v-app>
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import lb from "./util/lb";

  export default {
    name: "App",
    components: {
      gwsHeader: Header,
      gwsFooter: Footer
    },
    created() {
      if (process.env.API_HOST) {
        lb.defaults.baseURL = process.env.API_HOST;
      }
      const user = window.localStorage.getItem("user");
      const accesstoken = window.localStorage.getItem("accesstoken");
      if (user) {
        this.$store.commit("SET_CURRENT_USER", JSON.parse(user));
        this.$store.commit("SET_ACCESS_TOKEN", accesstoken);
      }
    }
  };
</script>

<style lang="scss">
  .skip-link {
    position: absolute;
    left: -9999px;
    top: 0;
    z-index: 10000;
    padding: 12px 18px;
    background: #1a7055;
    color: #fff !important;
    font-weight: 700;
    text-decoration: none;
    border-radius: 0 0 6px 0;
  }
  .skip-link:focus,
  .skip-link:focus-visible {
    left: 16px;
    top: 16px;
    border-radius: 6px;
    /* WCAG 2.4.7/2.4.11 — double-ring focus indicator: thick amber outer
       ring stacked over a thick dark inner ring. Each ring is wide enough
       to read at any zoom level and the contrast pair stays visible on
       both light and dark surfaces. */
    outline: 4px solid #ffbf47;
    outline-offset: 4px;
    box-shadow:
      0 0 0 3px #0d3d2e,                    /* inner dark stroke against amber */
      0 0 0 10px #ffbf47,                   /* second amber band (~30% slimmer) */
      0 0 0 13px #0d3d2e,                   /* outer dark stroke for contrast on light bg */
      0 8px 24px rgba(0, 0, 0, 0.45);       /* drop shadow lifts ring off page */
  }
  #main-content:focus {
    outline: none;
  }
  body {
    font-family: "Ropa Sans", sans-serif;
    .application.theme--light {
      background-color: #fff !important;
    }
    a {
      font-weight: 400;
      text-align: center;
      text-decoration: none;
      color: #1a7055;
    }
    a:hover {
      color: #0d3d2e;
      text-decoration: underline;
    }
    a:visited {
      color: #1a7055;
    }
  }
  /* WCAG 2.4.7 + 2.4.11 — two-color focus indicator that stays visible on
     BOTH light and dark backgrounds. The amber outline contrasts against
     dark surfaces (e.g. green buttons), and the dark box-shadow halo
     contrasts against light surfaces (e.g. white page background). */
  *:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
    box-shadow:
      0 0 0 2px #0d3d2e,        /* dark inner stroke — separates amber from element fill */
      0 0 0 7px rgba(13, 61, 46, 0.55); /* dark outer halo — visible on light bg */
  }
  /* WCAG 1.4.3 — placeholder text must meet 4.5:1 contrast on white */
  input::placeholder,
  textarea::placeholder,
  .v-text-field input::placeholder,
  .v-text-field textarea::placeholder {
    color: #595959 !important; /* 7:1 on white */
    opacity: 1 !important;
  }
  /* Vuetify floating labels and counters — bump contrast */
  .v-label,
  .v-input .v-label,
  .v-text-field__details,
  .v-counter {
    color: #595959 !important;
  }
  /* WCAG 1.4.1 — content links must be distinguishable beyond color.
     Auto-underline raw external links in prose. */
  main a[href^="http"]:not(.btn):not(.nav_btn):not(.btn_custom):not(.logo):not(.cta_btn):not(.know_more_link):not(.read-more-link):not(.skip-link),
  main a[href^="mailto:"]:not(.btn),
  main a[href^="tel:"]:not(.btn) {
    text-decoration: underline;
  }
  /* WCAG 2.3.3 — honor users' motion preferences globally */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
      scroll-behavior: auto !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue